import { useState, useEffect } from 'react';

const Toast = ({ toast, position, time }) => {

    const [list, setList] = useState([]);

    const POSITION_OPTIONS = {
        'bottom-center': {
            bottom: '32px',
            left: 'calc(50% - 160px)'
        }
    }

    useEffect(() => {
        setList([...toast]);
    }, [toast]);

    useEffect(() => {
        const interval = setInterval(() => {
            if (list.length) {
                setList([])
            }
        }, time);

        return () => {
            clearInterval(interval);
        }
    }, [toast, time, list]);

    return (
        <div className={`fixed`} style={POSITION_OPTIONS['bottom-center']}>
            {
                list.map((item, i) =>
                    <div key={i} className="w-80 bg-[#152536] text-white py-4 rounded-lg text-center"><p>{item.message}</p></div>
                )
            }
        </div>
    )
}
export default Toast;